import { Page, withModel } from '@adobe/cq-react-editable-components';
import React from 'react';

class Content extends Page {
  render(): any {
    return <div>{this.childComponents}</div>;
  }
}

export default withModel(Content);
